namespace GeniuzPOS.InitialData {
    export enum PsPosStationEunSellingPriceNo {
        SellingPriceNo1 = 1,
        SellingPriceNo2 = 2,
        SellingPriceNo3 = 3,
        SellingPriceNo4 = 4,
        SellingPriceNo5 = 5,
        SellingPriceNo6 = 6
    }
    Serenity.Decorators.registerEnumType(PsPosStationEunSellingPriceNo, 'GeniuzPOS.InitialData.PsPosStationEunSellingPriceNo');
}
